import React from "react"

const MapOverviewElement = ({ categoryName, color }) => {
  return (
    <li className="parking-legend__item">
      <span className="icon" style={{ backgroundColor: color }}>
        {categoryName.toLowerCase().startsWith("we park you fly") ? (
          <svg className="svg-icon svg-icon--keypickup">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-keypickup">
              &nbsp;
            </use>
          </svg>
        ) : (
          <span>P</span>
        )}
      </span>
      <span className="text">
        <strong>{categoryName}</strong>
      </span>
    </li>
  )
}

export default MapOverviewElement
